<template>
  <div id="app">
    <HeaderComponent :isHidden="isHeaderHidden" />

    <div class="scroll-container">
      <HeroSection />
      <PricingSection />
      <FeaturesSection />
     <!-- <TestimonialsSection />-->
      <FooterComponent />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import HeaderComponent from "../components/HeaderComponent.vue";
import HeroSection from "../components/HeroSection.vue";
import FeaturesSection from "../components/FeaturesSection.vue";
//import TestimonialsSection from "../components/TestimonialsSection.vue";
import PricingSection from "../components/PricingSection.vue";
import FooterComponent from "../components/FooterComponent.vue";

export default {


  components: {
    HeaderComponent,
    HeroSection,
    FeaturesSection,
   // TestimonialsSection,
    PricingSection,
    FooterComponent
  },
  setup() {
    const isHeaderHidden = ref(false);
    const smallScreen = ref(false)
    let lastScrollY = 0;
    let ticking = false;

    const smoothScroll = (event) => {
      event.preventDefault(); // Prevent default scrolling behavior

      const scrollContainer = document.querySelector(".scroll-container");
      if (!scrollContainer || ticking) return;

      ticking = true;

      const delta = event.deltaY; // Detect scroll direction
      const currentScrollTop = scrollContainer.scrollTop;
      const viewportHeight = window.innerHeight;
      const currentSide = Math.floor(currentScrollTop / viewportHeight)
      let nextScrollTop;

      if (delta > 0) {
        // Scrolling down
        nextScrollTop = (currentSide + 1) * viewportHeight; // Add 1 to avoid staying on the same section
      } else {
        // Scrolling up
        nextScrollTop = (currentSide - 1) * viewportHeight; // Subtract 1 to move to the previous section
      }


      // Clamp the scroll position within valid bounds
      nextScrollTop = Math.max(
        0,
        Math.min(scrollContainer.scrollHeight - viewportHeight, nextScrollTop)
      );

      // Smoothly scroll to the calculated position
      scrollContainer.scrollTo({
        top: nextScrollTop,
        behavior: "smooth",
      });

      // Reset the ticking flag after scrolling
      setTimeout(() => {
        ticking = false;
      }, 500); // Adjust for your animation duration
    };


    const checkScreenSize = () => {
      smallScreen.value = window.innerWidth <= 480;
    };


    const handleScroll = () => {
      const scrollContainer = document.querySelector(".scroll-container");
      if (!scrollContainer) return;

      const currentScrollY = scrollContainer.scrollTop;

      // Hide header when scrolling down, show when scrolling up
      isHeaderHidden.value = currentScrollY > lastScrollY && currentScrollY > 50;

      if(smallScreen.value == true && currentScrollY != 0)
        isHeaderHidden.value = true

      lastScrollY = currentScrollY;
    };

    onMounted(() => {
      checkScreenSize()
      const scrollContainer = document.querySelector(".scroll-container");
      if (scrollContainer) {
        scrollContainer.addEventListener("scroll", handleScroll); // Attach scroll event
        scrollContainer.addEventListener("wheel", smoothScroll, { passive: false }); // Attach smooth scroll logic
      }
    });

    onUnmounted(() => {
      const scrollContainer = document.querySelector(".scroll-container");
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll); // Remove scroll event
        scrollContainer.removeEventListener("wheel", smoothScroll); // Remove smooth scroll logic
      }
    });

    return {
      isHeaderHidden,
    };
  },
};
</script>

<style scoped>
@import '@/assets/styles.css';

.scroll-container {
  scroll-snap-type: y mandatory;
  /* Enable vertical snap scrolling */
  overflow-y: scroll;
  /* Allow vertical scrolling */
  height: 100vh;
  /* Ensure full-screen height for each section */

  /* Hide scrollbar while maintaining scroll functionality */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* Internet Explorer and Edge */
}

.scroll-container::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}

@media (max-width: 480px) {
  .header {
    display: none; /* Completely hide the header */
  }
}

section {
  scroll-snap-align: start;
  /* Snap at the start of each section */
  height: 100vh;
  /* Each section takes up the full viewport */
}

body {
  overflow-y: hidden;
}
</style>